<template>
  <div class="filter-group" data-testid="category-sorting">
    <h4>
      {{ $t('sortBy') }}
    </h4>
    <div>
      <div
        v-for="{ value, label } in options"
        :key="value"
        class="filter-option"
      >
        <input
          type="radio"
          :id="value"
          :value="value"
          v-model="selected"
          name="sort-options"
        />
        <label :for="value" class="cursor-pointer">
          {{ $t(`sortType.${label}`) }}
        </label>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, watch } from 'vue'
import { useRoute, useRouter } from 'vue-router'

const route = useRoute()
const router = useRouter()

const options = ref([
  { label: 'nameAZ', value: 'name-az' },
  { label: 'nameZA', value: 'name-za' },
  { label: 'priceUp', value: 'price-low-to-high' },
  { label: 'priceDown', value: 'price-high-to-low' },
])

const selected = ref(route.query.sort || options.value[0].value)

watch(selected, (newValue) => {
  // Use router.push instead of window.location.href for SPA navigation
  router.push({
    path: route.path,
    query: {
      ...route.query,
      sort: newValue,
      page: 1 // Reset to page 1 when sorting changes
    }
  })
})

// Watch for route changes to update selected value
watch(
  () => route.query.sort,
  (newSortValue) => {
    if (newSortValue && newSortValue !== selected.value) {
      selected.value = newSortValue
    }
  }
)
</script>